import { withCompController } from '@wix/editor-elements-integrations/src/thunderbolt';
import type { IRiveStateValues } from '../Rive.props';

export default withCompController<
  Record<string, any>,
  IRiveStateValues,
  never,
  IRiveStateValues
>(({ stateValues, mapperProps }) => {
  const { reducedMotion } = stateValues;
  return { ...mapperProps, reducedMotion };
});
